import React from 'react';
import { debounce } from 'lodash';

export default function DebounceInputChangeEnhancer(wait = 0, options = {}) {
    return function DebounceInputChangeHOC(WrappedComponent) {
        class DebounceInputChange extends React.Component {
            constructor(props) {
                super(props);

                this.state = {
                    value: props.value || ''
                };

                this.onChange = debounce(this.onChange.bind(this), wait, options);
                this.internalOnChange = this.internalOnChange.bind(this);
            }

            componentDidUpdate(prevProps) {
                if (prevProps.value !== this.props.value && this.state.value !== this.props.value) {
                    // incoming value changes
                    this.setState({
                        value: this.props.value
                    }, () => {
                        this.onChange();
                    });
                }
            }

            onChange() {
                return this.props.onChange(this.state.value);
            }

            internalOnChange(evt) {
                const value = evt.target.value;
                this.setState({
                    value
                }, () => {
                    this.onChange();
                });
            }

            render() {
                // Wraps the input component in a container, without mutating it. Good!
                return <WrappedComponent {...this.props} value={this.state.value} onChange={this.internalOnChange} />;
            }
        }

        return DebounceInputChange;
    };
}



// WEBPACK FOOTER //
// ./src/hoc/DebounceInputChange.js